// extracted by mini-css-extract-plugin
module.exports = {"wraper":"wraper--lgmWO","verifyForm":"verifyForm--BwB1a","highLight":"highLight--OJEOv","noMarginRight":"noMarginRight--cM9dw","hidedInput":"hidedInput--h-UdC"};